<!--文章：上下结构 标题+描述+图片+顺序-->
<template>
  <div class="v-article">
    <div v-for="(item,index) in articleVal.card.carditem" :key="index">
      <!-- 标题 -->
      <!-- <div class="title" v-if="item.title" v-html="item.title"></div> -->
      <!-- 描述 -->
      <!-- <div class="name"  v-if="item.title" v-html="'作者：'+item.title"></div> -->
      <!-- 内容 -->
      <img class="name" style="width:100%;" v-if="item.img" :src="item.img"/>
      <div class="content"  v-html="item.txtType=='markdown'?mark(item.txt):item.txt"></div>
    </div>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: 'v-article',
  props: {
      articleVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      defaultOpen:"preview",
      text:"#hello##hello world",
      articleData:{
        "title":"远程云教育平台",
        "content":"丰富试题类型，满足标准考试、调查问卷、心里测评等多种需求",
        "place":0,//结构0图上 1图下 2图左 3图右
        "type":1,//0默认 1圆角
        "list":[
        {
          "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          "content":"搭建企业大学，构建SASS云学院"
        },
        {
          "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          "content":"搭建企业大学，构建SASS云学院2"
        },
        {
          "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          "content":"搭建企业大学，构建SASS云学院3"
        },
        {
          "path":"//www.issedu365.com/media/midocument/examineadmin/taskfile/kh8p8qdl0l338f556im21i5wamago5nu/3eqe5c9h2p3e4okf.jpg",
          "content":"搭建企业大学，构建SASS云学院4本学院简介仅供参考"
        }
        ]
      },
      textMd:"# 132456 ##123456  >  一级"
    }
  },
  methods:{
    //转换md格式
    mark(_value){
      return marked(_value);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
